import { addTerms, getTerm, getTermFromStore } from "@sal/onevent-portal";
import { base } from "./base";
import { enAU } from "./enAU";
import { enNZ } from "./enNZ";

const locale = window.navigator.language;

const terms = {
	"default": {
		...base
	},
	"en-AU": {
		...base,
		...enAU
	},
	"en-NZ": {
		...base,
		...enNZ
	}
};

if (!terms[locale]) {
	terms[locale] = {
		...base
	};
}

addTerms(terms);

export { getTerm, getTermFromStore };
